import { ReactNode } from 'react'
import { typographyStyles } from '@qodana/blocks/lib/components/Typography'
import cn from 'classnames'

import styles from './Error.module.css'

type ErrorProps = {
	title: ReactNode
	content: ReactNode
}

export const Error = ({ title, content }: ErrorProps) => {
	return (
		<div className={styles.container}>
			<div>
				<div className={cn(styles.title, typographyStyles.pageTitle)}>{title}</div>
				<div className={typographyStyles.text}>{content}</div>
			</div>
		</div>
	)
}
